const initialState = {
    jobId: null
  };
  
  const jobReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_JOB_ID':
        return { ...state, jobId: action.payload };
      default:
        return state;
    }
  };
  
  export default jobReducer;
  